import React, { useState, useEffect, useCallback } from 'react';
// 🔑 6 Eyl 2026 — ikinci Toast kopyasi kaldirildi; hatalar ORTADA ve
//    KALICI gorunsun diye ortak bilesene baglandi (Ilke 3).
import Bildirim from './Bildirim';
import { supabase } from '../supabaseClient';
import AdminPanel, { FontControls } from './AdminPanel';
import { TAM_YUKSEKLIK, TAM_GENISLIK, vh } from '../yaziBoyutu';
import ThemeToggle from './ThemeToggle';
import { zAlan } from './tasarim';   // zorunlu alan rengi — iPad kuralı, kaydetme kapısının koşuluyla (5 Eki 2026)
import { FEATURE_KEYS, isEnabled, catalogTree, affectsOf, entryOf, toggleFeature, DEGER_AYARLARI, sayiOku } from './featureCatalog';
import { HESAP_ESASLARI } from './FTLEngine';   // FTL hesap esası değerleri — motorun tek eşleme noktası (31 Eki 2026)
import SystemMonitoring from './SystemMonitoring';
import SystemChecks from './SystemChecks';
import FtlGeceDurumu from './FtlGeceDurumu';
import CikisDugmesi from './CikisDugmesi';
import AppReleases from './AppReleases';
import AircraftTypes from './AircraftTypes';
import Registrations from './Registrations';
import Airports from './Airports';
import { meydanBilgisi } from './MeydanGirisi';
import ProfilHatasi, { profilOku } from './ProfilHatasi';
import { SAYILI, okumaDenetimi } from './kesikOkuma';   // okunamadı ≠ yok (21 Eki 2026)
import OkumaHatasi from './OkumaHatasi';   // giriş profili: tek okuma, okunamadı ≠ yok (21 Eki 2026)   // ana üs ICAO → ad + ülke + dilim, ağ hatası "yok" sayılmaz (21 Eki 2026)

import HarfliGiris from './HarfliGiris';
// Dilim farkini TEK KAYNAKTAN okuruz ve TEK BICIMLE yazariz (21 Eki 2026, K8): `dilimFarkMetni` — `tzOffsetMin`
// (`hourCycle:'h23'`, 19 Eyl kusuru) + "UTC+03:00". Burada kendi Intl cagrimizi ya da bicimimizi yazmayiz.
import { dilimFarkMetni } from './dilimKontrolu';
import { dugmeStili } from './tasarim';
import { usePencereKapat, KapatX } from './pencereKapat';   // pencere kapatma tek tip — ESC + ✕ (12 Eki 2026)
import { GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // ortak gerekçe kuralı + satırı (21 Eki 2026, K7)
const C = {
  bg:'var(--bg)', bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)', accent:'var(--accent)',
};

const S = {
  label:{fontSize:10,color:C.t3,fontWeight:700,letterSpacing:1,textTransform:'uppercase'},
  // 1 Eki 2026 — düğmeler ORTAK tasarımdan (tasarim.js, Serkan: "her modülün içinde butonlarda border, aynı tasarım"); eskiden bu dosyada ayrı tanımlıydı.
  btnPrimary:dugmeStili('birincil', { kucuk: true }),
  btnSecondary:dugmeStili('notr', { kucuk: true }),
  formGroup:{marginBottom:12},
  formLabel:{display:'block',fontSize:10,color:C.t3,fontWeight:700,letterSpacing:0.8,textTransform:'uppercase',marginBottom:5},
  input:{width:'100%',background:C.bg3,border:`1px solid ${C.border}`,borderRadius:6,padding:'9px 11px',fontSize:13,color:C.t1,fontFamily:'inherit',outline:'none',boxSizing:'border-box'},
  select:{width:'100%',background:C.bg3,border:`1px solid ${C.border}`,borderRadius:6,padding:'9px 11px',fontSize:13,color:C.t1,fontFamily:'inherit',outline:'none',boxSizing:'border-box'},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{textAlign:'left',padding:'8px 12px',fontSize:10,color:C.t3,fontWeight:700,letterSpacing:0.6,textTransform:'uppercase',borderBottom:`1px solid ${C.border}`},
  td:{padding:'9px 12px',fontSize:12,color:C.t2,borderBottom:`1px solid ${C.border}`},
};

// TASARIM BIRLIGI (10 Agu 2026, Serkan: "tasarim ogeleri her yerde hissedilsin").
// Super admin ekranlari admin panelin diliyle kurulur: ayni ust bar, sol menu,
// baslik seridi. Asagidaki uc yardimci admin panelin menu ogesiyle ayni gorunumu
// uretir — kopyala-yapistir yerine tek yerden.
const navRow = (on) => ({
  padding:'10px 12px', margin:'2px 0', cursor:'pointer', display:'flex',
  alignItems:'center', gap:10, borderRadius:8,
  background: on ? 'var(--accent-soft)' : 'transparent',
});
const navIcon = (on) => ({ fontSize:15, width:20, textAlign:'center', color: on ? C.accent : C.t3 });
const navText = (on) => ({
  fontSize:12, fontWeight: on ? 700 : 500, color: on ? C.accent : C.t2,
  letterSpacing:0.5, fontFamily:'var(--mono)', textTransform:'uppercase',
});



// Sirket LISTESI. Secim ust bilesende tutulur — sol menu secili sirketi
// gostermek zorunda, o yuzden durum yukarida yasar.
export function CompaniesList({ toast, onSelect, reloadKey, myProfile }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [saving, setSaving] = useState(false);
  usePencereKapat(saving ? null : () => setShowAdd(false), showAdd);   // ESC + ✕ (12 Eki 2026)
  // 🔑 ŞİRKET YÖNETİCİSİ KURULUŞUN PARÇASIDIR (21 Eyl 2026, Serkan):
  //    *"Bir şirket kurarken oraya bir tane yönetici atayalım — mail ve şifre.
  //    O yönetici kendi şirketinin kullanıcılarını kendi admin panelinden
  //    yapsın."* · *"Biz o aşamayı unuttuk."*
  //
  // 🔴 ÖLÇÜLDÜ: yol ASLINDA VARDI — süper admin şirketin panelini açıp
  //    CREWS → ADD CREW MEMBER ile ilk kullanıcıyı yaratabiliyordu. Ama
  //    hiçbir yerde yazmıyor, hiçbir şey hatırlatmıyordu: şirketi kurduğunda
  //    ekran "tamam" diyor, oysa o şirkete KİMSE GİREMİYOR. Kullanıcısı
  //    olmayan şirket, listede kurulmuş bir şirketle birebir aynı görünüyordu
  //    (İlke 1: sistem olmayan şeyi olmuş gibi göstermez).
  const BOS_FORM = { company_name:'', home_base_icao:'', contact_email:'', plan_type:'standard', max_users:10,
                     adm_full_name:'', adm_code:'', adm_email:'', adm_password:'', adm_role:'admin' };
  const [form, setForm] = useState(BOS_FORM);

  // 🔴 KULLANICISIZ SIRKET LISTEDE GORUNSUN (21 Eyl 2026). Bugune kadar
  //    yoneticisi olmayan sirket, kurulmus bir sirketle BIREBIR AYNI
  //    gorunuyordu — girilemedigi ancak denendiginde anlasilirdi.
  const [yoneticili, setYoneticili] = useState(null);   // Set | null(okunmadi)
  // 🔴 21 Eki 2026 (W4b): şirket listesinin okuma hatası okunmuyordu — düşünce liste boş ("0 COMPANIES") görünürdü.
  const [okumaHatasi, setOkumaHatasi] = useState(null);
  const load = useCallback(async () => {
    setLoading(true);
    const { dustu, oku } = okumaDenetimi();
    const data = oku('COMPANIES (customers)', await supabase.from('customers').select('*', SAYILI).order('company_name'));
    const prof = oku('ADMINISTRATORS (profiles)', await supabase.from('profiles')
      .select('customer_id,role', SAYILI).in('role', ['admin', 'admin_pilot']));
    setOkumaHatasi(dustu.length ? dustu : null);
    setList(dustu.length ? [] : (data || []));
    setYoneticili(!dustu.length && prof ? new Set(prof.map(r => r.customer_id).filter(Boolean)) : null);
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load, reloadKey]);

  const handleAdd = async () => {
    if (!form.company_name || !form.home_base_icao) { toast('Company name and home base (ICAO) required.', 'error'); return; }
    if (!form.adm_full_name || !form.adm_code || !form.adm_email || !form.adm_password) {
      toast('Administrator name, code, email and password are required — a company without a user cannot be reached.', 'error'); return;
    }
    if (form.adm_password.length < 8) { toast('Password must be at least 8 characters.', 'error'); return; }
    setSaving(true);

    // 1) SIRKET. Id lazim, o yuzden `.select().single()`.
    const { data: yeni, error } = await supabase.from('customers').insert({
      company_name: form.company_name,
      home_base_icao: form.home_base_icao.toUpperCase(),
      contact_email: form.contact_email || null,
      plan_type: form.plan_type,
      max_users: form.max_users,
      active: true,
    }).select().single();
    if (error) { setSaving(false); toast(error.message, 'error'); return; }

    // 2) YONETICI. Parola SUNUCUYA gider, baska hicbir yere yazilmaz —
    //    ne ize, ne ekrana, ne konsola. Service key yalniz Edge'de.
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/manage-user`, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${session?.access_token}` },
      body: JSON.stringify({ action:'create', email: form.adm_email, password: form.adm_password,
                             full_name: form.adm_full_name, code: form.adm_code,
                             role: form.adm_role, target_customer_id: yeni.id }),
    });
    const sonuc = await res.json().catch(() => ({}));
    setSaving(false);

    if (!res.ok) {
      // 🔴 SIRKETI GERI SILMIYORUZ: id'ye bagli baska kayit dogmus olabilir ve
      //    silmek daha kotu. Ama "kuruldu" da DEMIYORUZ — sirket kullanicisiz
      //    kaldi ve bu ekranda GORUNUR: listede NO ADMIN, kunyede kirmizi.
      toast(`Company created but the administrator was NOT: ${sonuc.error || 'user creation failed'} — `
          + `open COMPANY PROFILE and add one, otherwise nobody can log in.`, 'error');
      setShowAdd(false); setForm(BOS_FORM); load();
      return;
    }

    // 3) KURULUŞ ADMİNİ ŞİRKETE YAZILIR. Yeni şirkette bu alan boş kalmaz —
    //    REC'te boş kalmasının sebebi zaten bu adımın o zaman olmamasıydı.
    if (sonuc.user_id) {
      await supabase.from('customers')
        .update({ primary_admin_id: sonuc.user_id }).eq('id', yeni.id);
    }

    // 4) IZ (Ilke C-6). PAROLA YAZILMAZ.
    await supabase.from('superadmin_log').insert({
      actor_id: myProfile?.id ?? null, customer_id: yeni.id, type:'user_create',
      field:'administrator', old_value:null, new_value:`${form.adm_email} · ${form.adm_role}`,
      reason:`Initial administrator created with the company ${form.company_name}`,
    });

    toast(`${form.company_name} added with administrator ${form.adm_email}.`, 'success');
    setShowAdd(false); setForm(BOS_FORM); load();
  };

  const toggleActive = async (c, e) => {
    e.stopPropagation();
    const { error } = await supabase.from('customers').update({ active: !c.active }).eq('id', c.id);
    if (error) { toast(error.message, 'error'); return; }
    load();
  };

  return (
    <div style={{ flex:1, overflowY:'auto' }}>
      <div style={{ padding:'10px 16px', borderBottom:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={S.label}>{okumaHatasi ? 'COMPANIES NOT LOADED' : `${list.length} COMPANIES`}</span>
        <button style={S.btnPrimary} onClick={() => setShowAdd(true)}>+ ADD COMPANY</button>
      </div>
      {loading && <div style={{ padding:32, textAlign:'center', color:C.t3, fontSize:11 }}>LOADING...</div>}
      {okumaHatasi && <OkumaHatasi testid="sirket-okuma-hatasi" style={{ padding:'12px 16px' }} satirlar={okumaHatasi} onRetry={load}
        baslik="COMPANIES COULD NOT BE LOADED — this does not mean there are none." />}
      {!okumaHatasi && <table style={S.table}>
        <thead><tr>{['COMPANY','HOME BASE','EMAIL','PLAN','MAX USERS','STATUS'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
        <tbody>
          {list.map(c => (
            <tr key={c.id} onClick={() => onSelect(c)} style={{ cursor:'pointer' }}>
              <td style={{ ...S.td, color:C.accent, fontWeight:700 }}>
                {c.company_name}
                {yoneticili && !yoneticili.has(c.id) && (
                  <span data-testid={`no-admin-${c.id}`}
                        style={{ marginLeft:8, fontSize:9, fontWeight:700, padding:'2px 6px', borderRadius:4,
                                 background:'rgba(224,32,32,0.15)', color:'var(--red)' }}
                        title="This company has no administrator — nobody can sign in">NO ADMIN</span>
                )}
              </td>
              <td style={S.td}>{c.home_base_icao || '—'}</td>
              <td style={S.td}>{c.contact_email || '—'}</td>
              <td style={S.td}>{c.plan_type || '—'}</td>
              <td style={S.td}>{c.max_users ?? '—'}</td>
              <td style={S.td}>
                <span onClick={(e) => toggleActive(c, e)} style={{ cursor:'pointer', fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:4, background: c.active ? 'rgba(45,158,95,0.15)' : 'rgba(224,32,32,0.15)', color: c.active ? 'var(--green)' : 'var(--red)' }}>
                  {c.active ? 'ACTIVE' : 'INACTIVE'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>}
      {showAdd && (
        <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 }}>
          <div style={{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:12, width:520, maxHeight:vh(88), overflowY:'auto' }}>
            <div style={{ background:C.bg3, padding:'10px 16px', borderBottom:`1px solid ${C.border}`, fontSize:12, fontWeight:700, color:C.accent,
                          display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
              ADD COMPANY<KapatX onClose={() => setShowAdd(false)} disabled={saving} />
            </div>
            <div style={{ padding:'16px' }}>
              <div style={S.formGroup}>
                <label style={S.formLabel}>COMPANY NAME *</label>
                <HarfliGiris {...zAlan(S.input, true, !!form.company_name)} data-testid="co-name" value={form.company_name} onChange={v => setForm(p => ({ ...p, company_name:v }))} />
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>HOME BASE (ICAO) *</label>
                <HarfliGiris {...zAlan(S.input, true, !!form.home_base_icao)} maxLength={4} data-testid="co-home-base" value={form.home_base_icao} onChange={v => setForm(p => ({ ...p, home_base_icao:v }))} />
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>CONTACT EMAIL</label>
                <input style={S.input} type="email" value={form.contact_email} onChange={e => setForm(p => ({ ...p, contact_email:e.target.value }))} />
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>PLAN TYPE</label>
                <select style={S.select} value={form.plan_type} onChange={e => setForm(p => ({ ...p, plan_type:e.target.value }))}>
                  <option value="standard">Standard</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>MAX USERS</label>
                <input style={S.input} type="number" value={form.max_users} onChange={e => setForm(p => ({ ...p, max_users:parseInt(e.target.value) || 0 }))} />
              </div>
              {/* ── ŞİRKET YÖNETİCİSİ — KURULUŞUN PARÇASI ──────────────────
                  Serkan: *"Bir şirket kurarken oraya bir tane yönetici atayalım;
                  o yönetici kendi şirketinin kullanıcılarını kendi admin
                  panelinden yapsın."* Ayrı adım BIRAKILMADI: şirketi kurup
                  yöneticiyi unutmak, giriş yapılamayan bir şirket demek. */}
              <div style={{ borderTop:`1px solid ${C.border}`, margin:'18px 0 14px', paddingTop:14 }}>
                <div style={{ ...S.label, marginBottom:4 }}>ADMINISTRATOR</div>
                <div style={{ fontSize:10, color:C.t3, marginBottom:10, lineHeight:1.5 }}>
                  This person receives the login and then adds their own pilots and aircraft
                  from their company's admin panel. Without one, nobody can sign in.
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <div style={S.formGroup}>
                  <label style={S.formLabel}>FULL NAME *</label>
                  <HarfliGiris {...zAlan(S.input, true, !!form.adm_full_name)} data-testid="adm-full-name" value={form.adm_full_name}
                               onChange={v => setForm(p => ({ ...p, adm_full_name:v }))} />
                </div>
                <div style={S.formGroup}>
                  <label style={S.formLabel}>CODE *</label>
                  <HarfliGiris {...zAlan(S.input, true, !!form.adm_code)} maxLength={5} placeholder="AAK" data-testid="adm-code" value={form.adm_code}
                               onChange={v => setForm(p => ({ ...p, adm_code:v.toUpperCase() }))} />
                </div>
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>EMAIL *</label>
                <input {...zAlan(S.input, true, !!form.adm_email)} type="email" placeholder="admin@company.com" data-testid="adm-email" value={form.adm_email}
                       onChange={e => setForm(p => ({ ...p, adm_email:e.target.value }))} />
              </div>
              {/* 🔑 ROL BURADA SABIT: `admin`. Serkan: *"crew legal modül, FTL
                  modül vs. bunlar pilotlar için; zaten pilotu girerken tip
                  yetkisi, saat vs. giriyoruz."* Burada `admin_pilot`
                  seçilebilseydi TABAN DEĞERİ, TİP YETKİSİ ve ANA ÜSSÜ OLMAYAN
                  bir pilot doğardı — FTL paneli onu kırmızı `NOT SET` diye
                  taşımak zorunda kalırdı. Yönetici aynı zamanda uçuyorsa rolünü
                  kendi panelinden değiştirir ve pilot verisini oraya girer. */}
              <div style={S.formGroup}>
                <label style={S.formLabel}>TEMP PASSWORD *</label>
                <input {...zAlan(S.input, true, (form.adm_password || '').length >= 8)} type="password" placeholder="Min 8 chars" data-testid="adm-password" value={form.adm_password}
                       onChange={e => setForm(p => ({ ...p, adm_password:e.target.value }))} />
                <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
                  Role: ADMIN. If this person also flies, their company admin changes the role
                  in CREWS & OFFICERS and enters the pilot data (type rating, hours, FTL baseline) there.
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
                <button style={S.btnSecondary} onClick={() => setShowAdd(false)}>CANCEL</button>
                <button style={S.btnPrimary} onClick={handleAdd} disabled={saving}
                        data-testid="add-company">{saving ? 'ADDING...' : 'ADD COMPANY'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ŞİRKET KÜNYESİ — KURULUŞTAKİ HER ALAN DÜZENLENEBİLİR (21 Eyl 2026) ─────
//
// 🔑 Serkan: *"Super admin panelde şirket ekleme veya şirket profili edit etme
//    hanesine bir de home base ICAO ekle; oraya ICAO girince zaten ülke de
//    çıkar otomatik."* · *"Burada kuruluş sırasındaki dahil her şey edit
//    edilebilmeli."*
//
// 🔴 ÖLÇÜLDÜ (21 Eyl): künye KURULUŞTA BİR KEZ yazılıyor ve bir daha hiç
//    değişmiyordu. `Settings` ekranı yalnız `features` + `max_users` yamıyor;
//    şirket adı, e-posta, plan ve ana üs için düzenleme yolu YOKTU.
//
// 🔑 NEDEN HOME BASE BURADA: eğitim/lisans geçerlilik sayaçları ŞİRKETİN yerel
//    gününe göre tutulur — *"şirket nerdeyse eğitim zamanları oraya göre
//    tutulur; pilotun home base'i başka şehir olabilir çok uçaklı ve pilotlu
//    yapılarda, şirket eğitimi kendi lokaline göre takip eder."* Dilim bu
//    meydanın `airports.tz`'sinden çözülür; ülke `iso_country`'den TÜRETİLİR,
//    ayrıca saklanmaz (İlke 3).
//
// 🔑 ESKİ `icao_code` ALANI BUDUR. Serkan: *"REC yazması saçma, oraya şirketin
//    home base'ini yazabiliriz; REC resmî bir 3'lü kod değil."* Kolon
//    `home_base_icao` olarak yeniden adlandırıldı — adı içeriğini söylemeyen
//    bir alan, üç ay sonra okuyanı yanıltır.
//
// ⚠️ KAPI DEĞİŞMEDİ: gerekçe zorunlu · iz ÖNCE `superadmin_log`'a · log
//    yazılamazsa HİÇBİR ŞEY uygulanmaz. Süper admin değişiklik yapabilir ama
//    izsiz yapamaz (İlke C-6).
const PROFIL_ALANLARI = [
  { key:'company_name',   label:'COMPANY NAME',      tip:'harf' },
  // 🔑 KURULUŞ ADMİNİ (21 Eyl 2026, Serkan): *"REC'te bir ilk kuruluş admini
  //    tanımlanmamıştı, Batuhan Çalış'ı kuruluş admini olarak ekleyelim."*
  //    Yeni şirkette kuruluşta kendiliğinden dolar; eski şirketlerde boştur ve
  //    boş olduğu GÖRÜNÜR. Devredilebilir — insanlar ayrılır.
  //    ⚠️ Bu alan bir ATAMA kaydıdır, bir yaratma kaydı değil: "bu kişi bugün
  //    itibarıyla şirketin kuruluş yöneticisidir" der. Geçmişe dönük bir iddia
  //    taşımaz (Batuhan 15 Tem'de eski yolla yaratıldı, o yol iz bırakmıyordu).
  { key:'primary_admin_id', label:'FOUNDING ADMIN',  tip:'admin' },
  { key:'home_base_icao', label:'HOME BASE (ICAO)',  tip:'icao' },
  { key:'contact_email',  label:'CONTACT EMAIL',     tip:'email' },
  { key:'plan_type',      label:'PLAN TYPE',         tip:'plan' },
  { key:'max_users',      label:'MAX USERS',         tip:'sayi' },
  { key:'active',         label:'STATUS',            tip:'aktif' },
];

// UTC farkı: TEK yazım `dilimKontrolu.dilimFarkMetni` (21 Eki 2026, K8) — buradaki `utcFarki` oraya taşındı.

// ── ŞİRKETİN YÖNETİCİLERİ — "BU ŞİRKETE KİM GİREBİLİR?" ───────────────────
//
// 🔴 Bu bölüm İKİNCİ ŞANS için var. Kuruluşta yönetici zorunlu; ama yönetici
//    adımı düşerse (e-posta zaten kayıtlı, parola kısa, ağ gitti) şirket
//    kullanıcısız kalır. O hâl EKRANDA DURMAZ — kırmızı görünür ve buradan
//    kapatılır. Sessiz kalan bir "girilemeyen şirket" İlke 1 ihlalidir.
function Yoneticiler({ customer, toast, myProfile }) {
  const [liste, setListe] = useState(null);         // null = henüz okunmadı
  const [ekle, setEkle]   = useState(false);
  const [f, setF]         = useState({ full_name:'', code:'', email:'', password:'' });
  const [saving, setSaving] = useState(false);

  // 🔴 21 Eki 2026 (W4b): okuma hatası okunmuyordu — düşünce kırmızı "NO ADMINISTRATOR — nobody can sign in" YANLIŞ
  //    ALARMI çıkıyordu. Artık kutu + RETRY.
  const [okumaHatasi, setOkumaHatasi] = useState(null);
  const yukle = useCallback(async () => {
    const { dustu, oku } = okumaDenetimi();
    const data = oku('USERS (profiles)', await supabase.from('profiles')
      .select('id,full_name,code,email,role', SAYILI).eq('customer_id', customer.id));
    setOkumaHatasi(dustu.length ? dustu : null);
    setListe(dustu.length ? [] : (data || []));
  }, [customer.id]);
  useEffect(() => { yukle(); }, [yukle]);

  const yoneticiler = (liste || []).filter(p => ['admin','admin_pilot'].includes(p.role));

  const kaydet = async () => {
    if (!f.full_name || !f.code || !f.email || !f.password) { toast('All fields are required.', 'error'); return; }
    if (f.password.length < 8) { toast('Password must be at least 8 characters.', 'error'); return; }
    setSaving(true);
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/manage-user`, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${session?.access_token}` },
      body: JSON.stringify({ action:'create', email:f.email, password:f.password,
                             full_name:f.full_name, code:f.code, role:'admin',
                             target_customer_id: customer.id }),
    });
    const sonuc = await res.json().catch(() => ({}));
    setSaving(false);
    if (!res.ok) { toast(sonuc.error || 'User creation failed', 'error'); return; }
    // İZ — PAROLA YAZILMAZ. 21 Eki 2026 (W4b): hatası okunur — kullanıcı sunucuda açıldığı için iz önce yazılamaz; düşerse
    // ekran bunu söyler (eskiden "added" deyip geçiyordu, yönetici izsiz kalıyordu).
    const { error: izHatasi } = await supabase.from('superadmin_log').insert({
      actor_id: myProfile?.id ?? null, customer_id: customer.id, type:'user_create',
      field:'administrator', old_value:null, new_value:`${f.email} · admin`,
      reason:'Administrator added from company profile',
    });
    if (izHatasi) toast(`${f.full_name} added, but the GO2 log could not be written (${izHatasi.message}) — record it by hand.`, 'error');
    else toast(`${f.full_name} added.`, 'success');
    setF({ full_name:'', code:'', email:'', password:'' }); setEkle(false); yukle();
  };

  if (liste === null) return null;

  return (
    <div style={{ border:`1px solid ${C.border}`, borderRadius:8, marginBottom:18, overflow:'hidden' }}
         data-testid="yoneticiler">
      <div style={{ background:C.bg3, padding:'8px 12px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={S.label}>ADMINISTRATORS</span>
        {!ekle && <button style={S.btnSecondary} onClick={() => setEkle(true)} data-testid="add-admin">+ ADD ADMIN</button>}
      </div>
      <div style={{ padding:'10px 12px' }}>
        {okumaHatasi ? (
          <OkumaHatasi testid="yonetici-okuma-hatasi" satirlar={okumaHatasi} onRetry={yukle}
            baslik="ADMINISTRATORS COULD NOT BE LOADED — this does not mean there are none." />
        ) : yoneticiler.length === 0 ? (
          <div data-testid="no-admin" style={{ color:'var(--red)', fontSize:12, fontWeight:700 }}>
            NO ADMINISTRATOR — nobody can sign in to this company.
            <div style={{ fontWeight:400, color:C.t2, fontSize:11, marginTop:4 }}>
              The company exists but has no user. Add one here; that person then creates
              their own pilots and aircraft from their admin panel.
            </div>
          </div>
        ) : yoneticiler.map(a => (
          <div key={a.id} style={{ fontSize:12, color:C.t2, fontFamily:'var(--mono)' }}>
            {a.code || '—'} · {a.full_name} · {a.email} · {(a.role || '').toUpperCase()}
          </div>
        ))}
        <div style={{ fontSize:10, color:C.t3, marginTop:8 }}>
          {liste.length} user(s) in this company
        </div>

        {ekle && (
          <div style={{ borderTop:`1px solid ${C.border}`, marginTop:10, paddingTop:10 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              <div style={S.formGroup}>
                <label style={S.formLabel}>FULL NAME *</label>
                <HarfliGiris {...zAlan(S.input, true, !!f.full_name)} data-testid="kul-ad" value={f.full_name} onChange={v => setF(p => ({ ...p, full_name:v }))} />
              </div>
              <div style={S.formGroup}>
                <label style={S.formLabel}>CODE *</label>
                <HarfliGiris {...zAlan(S.input, true, !!f.code)} data-testid="kul-kod" maxLength={5} value={f.code} onChange={v => setF(p => ({ ...p, code:v.toUpperCase() }))} />
              </div>
            </div>
            <div style={S.formGroup}>
              <label style={S.formLabel}>EMAIL *</label>
              <input {...zAlan(S.input, true, !!f.email)} data-testid="kul-eposta" type="email" value={f.email} onChange={e => setF(p => ({ ...p, email:e.target.value }))} />
            </div>
            <div style={S.formGroup}>
              <label style={S.formLabel}>TEMP PASSWORD *</label>
              <input {...zAlan(S.input, true, (f.password || '').length >= 8)} data-testid="kul-sifre" type="password" placeholder="Min 8 chars" value={f.password}
                     onChange={e => setF(p => ({ ...p, password:e.target.value }))} />
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button style={S.btnSecondary} onClick={() => setEkle(false)}>CANCEL</button>
              <button style={S.btnPrimary} onClick={kaydet} disabled={saving}
                      data-testid="save-admin">{saving ? 'CREATING…' : 'CREATE ADMIN'}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export function CompanyProfile({ customer, toast, myProfile, onSaved }) {
  const ilk = () => ({
    company_name:     customer.company_name || '',
    primary_admin_id: customer.primary_admin_id || '',
    home_base_icao: customer.home_base_icao || '',
    contact_email:  customer.contact_email || '',
    plan_type:      customer.plan_type || 'standard',
    max_users:      String(customer.max_users ?? ''),
    active:         customer.active !== false,
  });
  const [form, setForm]   = useState(ilk);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  // Meydan karşılığı: {durum:'bos'|'araniyor'|'var'|'yok'|'okunamadi', ad, ulke, tz}
  const [meydan, setMeydan] = useState({ durum:'bos' });
  const [meydanDeneme, setMeydanDeneme] = useState(0);   // RETRY — okunamayan sorguyu yeniden sorar
  // Kuruluş admini SEÇİLİR, elle id yazılmaz — o şirketin kendi kullanıcıları.
  const [kisiler, setKisiler] = useState([]);
  // 21 Eki 2026 (W4b): okunamazsa seçici kapanır ve söyler — eskiden boş liste "bu şirkette kimse yok" gibi görünüyordu.
  const [kisiHatasi, setKisiHatasi] = useState(null);
  const [kisiDeneme, setKisiDeneme] = useState(0);
  useEffect(() => {
    let dead = false;
    (async () => {
      const { data, error } = await supabase.from('profiles')
        .select('id,code,full_name,role').eq('customer_id', customer.id);
      if (dead) return;
      setKisiHatasi(error ? (error.message || String(error)) : null);
      setKisiler(error ? [] : (data || []));
    })();
    return () => { dead = true; };
  }, [customer.id, kisiDeneme]);

  // `ilk` her render'da yeniden kurulur; bagimlilik listesine koymak sonsuz
  // donguye sokar. Amac tek: SIRKET DEGISINCE formu bastan doldur.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setForm(ilk()); setReason(''); }, [customer]);

  // ICAO YAZILINCA AD + ÜLKE OTOMATİK. Bulunamazsa KABUL EDİLMEZ — "girildi
  // ama karşılığı yok" bir ana üs değildir, ve dilim de ondan çözülüyor.
  useEffect(() => {
    const kod = (form.home_base_icao || '').toUpperCase();
    if (kod.length !== 4) { setMeydan({ durum:'bos' }); return; }
    let dead = false;
    setMeydan({ durum:'araniyor' });
    // 🔴 21 Eki 2026 (kod taraması W4): kendi sorgusu hatayı okumuyordu — ağ düşünce "NOT IN AIRPORT DATABASE" derdi.
    //    Artık ortak `meydanBilgisi` (MeydanGirisi): düşen sorgu null döner → "okunamadı", "yok" DEĞİL.
    (async () => {
      const b = await meydanBilgisi(kod);
      if (dead) return;
      setMeydan(!b ? { durum:'okunamadi' }
              : b.var ? { durum:'var', ad:b.ad, ulke:b.ulke, tz:b.tz }
              : { durum:'yok' });
    })();
    return () => { dead = true; };
  }, [form.home_base_icao, meydanDeneme]);

  const degisenler = PROFIL_ALANLARI.filter(a => {
    const eski = a.key === 'max_users' ? String(customer.max_users ?? '')
               : a.key === 'active'    ? (customer.active !== false)
               : (customer[a.key] || (a.key === 'plan_type' ? 'standard' : ''));
    // (kurulus admini de duz alan gibi karsilastirilir — id'ler esitlenir)
    return form[a.key] !== eski;
  });
  const dirty = degisenler.length > 0;

  const kaydet = async () => {
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    if (!form.company_name.trim()) { toast('Company name cannot be empty.', 'error'); return; }
    if (meydan.durum === 'yok') { toast('Home base is not in the airport database.', 'error'); return; }
    if (meydan.durum === 'okunamadi') { toast('Home base could not be checked — the airport database could not be read. Try again.', 'error'); return; }
    if (!form.home_base_icao) { toast('Home base (ICAO) is required.', 'error'); return; }
    setSaving(true);

    // İZ ÖNCE (Ilke C-6). Alan BAŞINA satır: denetçi "neyin neye döndüğünü"
    // tek tek görür, tek bir "profile updated" satırı değil.
    const base = { actor_id: myProfile?.id ?? null, customer_id: customer.id, reason: reason.trim() };
    const rows = degisenler.map(a => ({
      ...base,
      // `max_users` eskiden beri `limit_change` — geçmiş tek tip kalsın diye
      // onu bozmuyoruz; geri kalan künye alanları `profile_change`.
      type: a.key === 'max_users' ? 'limit_change' : 'profile_change',
      field: a.key,
      old_value: a.key === 'max_users' ? (customer.max_users ?? null)
               : a.key === 'active'    ? (customer.active !== false)
               : (customer[a.key] ?? null),
      new_value: a.key === 'max_users' ? Number(form.max_users || 0)
               : a.key === 'active'    ? form.active
               : form[a.key],
    }));
    const { error: logErr } = await supabase.from('superadmin_log').insert(rows);
    if (logErr) { setSaving(false); toast(`Audit write failed, nothing applied: ${logErr.message}`, 'error'); return; }

    const patch = {
      company_name:     form.company_name.trim(),
      // Boş seçim NULL yazılır — "atanmadı" hâli saklanabilir olmalı.
      primary_admin_id: form.primary_admin_id || null,
      home_base_icao: form.home_base_icao.toUpperCase(),
      contact_email:  form.contact_email.trim() || null,
      plan_type:      form.plan_type,
      max_users:      Number(form.max_users || 0),
      active:         form.active,
    };
    const { data, error } = await supabase.from('customers').update(patch).eq('id', customer.id).select().single();
    setSaving(false);
    if (error) { toast(error.message, 'error'); return; }
    setReason('');
    toast(`${data.company_name} profile saved.`, 'success');
    onSaved && onSaved(data);
  };

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  // Özette ve izde ÇIPLAK id görünmesin — denetçi uuid okumaz, isim okur.
  const ozet = (key, deger, c) => {
    if (key === 'active') return String(c.active !== false);
    if (key !== 'primary_admin_id') return String(deger ?? '—');
    if (!deger) return 'NOT SET';
    const k = kisiler.find(x => x.id === deger);
    return k ? `${k.code || '—'} · ${k.full_name}` : String(deger);
  };

  return (
    <div style={{ flex:1, overflowY:'auto', padding:'16px' }} data-testid="company-profile">
      <Yoneticiler customer={customer} toast={toast} myProfile={myProfile} />
      <div style={{ maxWidth:520 }}>
        <div style={S.formGroup}>
          <label style={S.formLabel}>COMPANY NAME *</label>
          <HarfliGiris {...zAlan(S.input, true, !!String(form.company_name || '').trim())} data-testid="profil-ad" value={form.company_name} onChange={v => set('company_name', v)} />
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>HOME BASE (ICAO) *</label>
          <HarfliGiris {...zAlan(S.input, true, !!form.home_base_icao && meydan.durum !== 'yok')} data-testid="profil-us" maxLength={4} value={form.home_base_icao}
                       onChange={v => set('home_base_icao', v.toUpperCase())} />
          {/* Girilen kodun KARSILIGI gosterilir: dogru meydani yazdigini
              gorerek anlasin, koda guvenerek degil. */}
          {meydan.durum === 'araniyor' && (
            <div style={{ fontSize:11, color:C.t3, marginTop:5 }}>LOOKING UP…</div>)}
          {meydan.durum === 'var' && (
            /* 🔴 21 Eyl — GÖSTERİM YANILTIYORDU. Ham IANA adı (`Europe/Istanbul`)
               meydan adının yanında durunca *"Esenboğa İstanbul'da"* diye
               okunuyordu (Serkan yakaladı). Oysa o bir ŞEHİR değil, bütün
               Türkiye'nin DİLİM KİMLİĞİ. Havacıda karşılığı olan biçim UTC
               farkıdır; dilim adı kaybolmasın diye başlıkta durur. */
            <div data-testid="home-base-ok" style={{ fontSize:11, color:'var(--green)', marginTop:5 }}
                 title={meydan.tz ? `IANA time zone: ${meydan.tz}` : undefined}>
              {meydan.ad} · {meydan.ulke || '—'}{meydan.tz ? ` · ${dilimFarkMetni(meydan.tz)}` : ''}
            </div>)}
          {meydan.durum === 'yok' && (
            <div data-testid="home-base-yok" style={{ fontSize:11, color:'var(--red)', marginTop:5 }}>
              NOT IN AIRPORT DATABASE
            </div>)}
          {meydan.durum === 'okunamadi' && (
            <div data-testid="home-base-okunamadi" style={{ fontSize:11, color:'var(--orange)', marginTop:5 }}>
              AIRPORT DATABASE COULD NOT BE READ — this does not mean the code is wrong.{' '}
              <button type="button" style={{ ...dugmeStili('notr'), marginLeft:6 }} onClick={() => setMeydanDeneme(n => n + 1)}>RETRY</button>
            </div>)}
          {meydan.durum === 'var' && !meydan.tz && (
            <div style={{ fontSize:11, color:'var(--orange)', marginTop:4 }}>
              NO TIME ZONE ON RECORD — local-day counters cannot use this aerodrome yet
            </div>)}
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>FOUNDING ADMIN</label>
          {kisiHatasi && (
            <div data-testid="founding-okunamadi" style={{ fontSize:11, color:'var(--orange)', marginBottom:5 }}>
              USERS COULD NOT BE READ ({kisiHatasi}) — the founding administrator cannot be chosen now.{' '}
              <button type="button" style={{ ...dugmeStili('notr'), marginLeft:6 }} onClick={() => setKisiDeneme(n => n + 1)}>RETRY</button>
            </div>)}
          <select style={S.select} data-testid="founding-admin" disabled={!!kisiHatasi}
                  value={form.primary_admin_id || ''}
                  onChange={e => set('primary_admin_id', e.target.value)}>
            <option value="">— NOT SET —</option>
            {kisiler.map(k => (
              <option key={k.id} value={k.id}>
                {(k.code || '—')} · {k.full_name} · {(k.role || '').toUpperCase()}
              </option>
            ))}
          </select>
          {!form.primary_admin_id && (
            <div data-testid="founding-not-set" style={{ fontSize:11, color:'var(--red)', marginTop:5 }}>
              NOT SET — this company has no founding administrator on record
            </div>)}
          <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
            Recorded as of today; it does not claim who created the company.
          </div>
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>CONTACT EMAIL</label>
          <input style={S.input} type="email" value={form.contact_email}
                 onChange={e => set('contact_email', e.target.value)} />
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>PLAN TYPE</label>
          <select style={S.select} value={form.plan_type} onChange={e => set('plan_type', e.target.value)}>
            <option value="standard">Standard</option>
            <option value="premium">Premium</option>
          </select>
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>MAX USERS</label>
          <input style={S.input} type="number" value={form.max_users}
                 onChange={e => set('max_users', e.target.value)} />
        </div>

        <div style={S.formGroup}>
          <label style={S.formLabel}>STATUS</label>
          <select style={S.select} value={form.active ? 'active' : 'inactive'}
                  onChange={e => set('active', e.target.value === 'active')}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {dirty && (
          <>
            <div style={{ border:`1px solid ${C.border}`, borderRadius:8, padding:'10px 12px', marginBottom:12, background:C.bg3 }}>
              <div style={{ ...S.label, marginBottom:6 }}>{degisenler.length} CHANGE(S)</div>
              {degisenler.map(a => (
                <div key={a.key} style={{ fontSize:11, color:C.t2, fontFamily:'var(--mono)' }}>
                  {a.label}: {ozet(a.key, customer[a.key], customer)} → {ozet(a.key, form[a.key], customer)}
                </div>
              ))}
            </div>
            <div style={S.formGroup}>
              <label style={S.formLabel}>REASON * (goes to the audit trail)</label>
              <HarfliGiris as="textarea" {...zAlan({ ...S.input, minHeight:64, resize:'vertical' }, true, gerekceTamam(reason))}
                           data-testid="profil-gerekce" value={reason} onChange={v => setReason(v)}
                           placeholder="e.g. HOME BASE CORRECTED AFTER OFFICE MOVE" />
              <GerekceIpucu metin={reason} testid="profil-gerekce-ipucu" />
            </div>
          </>
        )}

        <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
          <button style={S.btnSecondary} onClick={() => { setForm(ilk()); setReason(''); }} disabled={!dirty}>REVERT</button>
          <button style={S.btnPrimary} onClick={kaydet} disabled={!dirty || saving}
                  data-testid="profile-save">{saving ? 'SAVING…' : 'SAVE & LOG'}</button>
        </div>
      </div>
    </div>
  );
}

// ── FTL HESAP ESASI — ŞİRKET SEÇİMİ (31 Eki 2026) ─────────────────────────────────────────────────────────────
// 🔑 REC geri bildirimi (Serkan 30 Eki): *"uçuşun türü ne olursa olsun SHT-FTL uygulanacak"* — süper admin şirket başına
//    seçer: ALL SHT-FTL / ALL GENERAL AVIATION / ikisi birden (türe göre — bugünkü). Değer `customers.ftl_hesap_esasi`'de
//    (features DEĞİL: iPad onu yalnız açık/kapalı diye çözer); motor onu görevin kural seti kopyasından okur (`hesapTuru`).
//    Sayı yazılmaz — limitler kural setinde durur, metin yalnız maddeyi söyler.
export const FTL_ESAS_ANAHTARI = 'admin.ftl';   // seçim bu modülün satırının altında görünür
export const FTL_ESAS_SECENEKLERI = [
  { deger: 'sht', etiket: 'ALL SHT-FTL',
    aciklama: "Every flight — training included — with Md.22 Table 1 (air taxi). The flight's own type stays on record." },
  { deger: 'ga', etiket: 'ALL GENERAL AVIATION',
    aciklama: "Every flight — training included — with Md.25 (general aviation). The flight's own type stays on record." },
  { deger: null, etiket: 'BOTH — BY FLIGHT TYPE',
    aciklama: 'Air taxi Md.22 · general aviation Md.25 · training Md.27 · ferry the tightest of its company types.' },
];
export const ftlEsasEtiketi = (deger) => (FTL_ESAS_SECENEKLERI.find(o => o.deger === (deger ?? null)) || {}).etiket
  || String(deger);
// Motorun tanıdığı her esasın burada bir satırı olmalı (test: HesapEsasiPanel.test.js).
export const FTL_ESAS_DEGERLERI = Object.keys(HESAP_ESASLARI);

// Sirketin deger ayarlari (DEGER_AYARLARI, 3 Kas 2026) — hucrede METIN tutulur, kayitta sayi.
const ilkDegerler = (c) => Object.fromEntries(DEGER_AYARLARI.map(d => [d.column, c[d.column] == null ? '' : String(c[d.column])]));

// Sirket bazli modul/hucre yetkilendirmesi.
// Tam tasarim: GO2EFB/CLAUDE.md -> "SUPER ADMIN SETTINGS — onayli tasarim".
// Katalog kodda (featureCatalog.js), DB'de yalnizca SAPMALAR (customers.features).
export function Settings({ customer, toast, myProfile, onSaved }) {
  const [saved, setSaved]       = useState(customer.features || {});
  const [draft, setDraft]       = useState(customer.features || {});
  const [maxUsers, setMaxUsers] = useState(String(customer.max_users ?? ''));
  const [esasKayitli, setEsasKayitli] = useState(customer.ftl_hesap_esasi ?? null);   // FTL hesap esası (31 Eki 2026)
  const [esas, setEsas]         = useState(customer.ftl_hesap_esasi ?? null);
  const [degerKayitli, setDegerKayitli] = useState(() => ilkDegerler(customer));   // FUEL DEFAULT DENSITY (3 Kas 2026)
  const [deger, setDeger]       = useState(() => ilkDegerler(customer));
  const [confirming, setConfirming] = useState(false);
  const [reason, setReason]     = useState('');
  const [saving, setSaving]     = useState(false);
  usePencereKapat(saving ? null : () => setConfirming(false), confirming);   // ESC + ✕ (12 Eki 2026)

  useEffect(() => {
    setSaved(customer.features || {});
    setDraft(customer.features || {});
    setMaxUsers(String(customer.max_users ?? ''));
    setEsasKayitli(customer.ftl_hesap_esasi ?? null); setEsas(customer.ftl_hesap_esasi ?? null);
    setDegerKayitli(ilkDegerler(customer)); setDeger(ilkDegerler(customer));
    setConfirming(false); setReason('');
  }, [customer]);

  const changed      = FEATURE_KEYS.filter(k => isEnabled(saved, k) !== isEnabled(draft, k));
  const closingKeys  = changed.filter(k => !isEnabled(draft, k));
  const openingKeys  = changed.filter(k =>  isEnabled(draft, k));
  const limitChanged = Number(maxUsers || 0) !== (customer.max_users ?? 0);
  const esasDegisti  = esas !== esasKayitli;
  // Deger: sayi olarak karsilastirilir ("0,795" = 0.795 degisiklik degil). Dokunulan hucre sayi degilse kayit kilitli;
  // dokunulmayan hucre kaydi kilitlemez (baska bir ayari degistirirken o deger yazilmaz).
  const hataliDegerler  = DEGER_AYARLARI.filter(d => deger[d.column] !== degerKayitli[d.column] && sayiOku(deger[d.column]) === null);
  const degisenDegerler = DEGER_AYARLARI.filter(d => !hataliDegerler.includes(d)
                                                  && sayiOku(deger[d.column]) !== sayiOku(degerKayitli[d.column]));
  const dirty        = changed.length > 0 || limitChanged || esasDegisti || degisenDegerler.length > 0 || hataliDegerler.length > 0;

  // ANAHTAR CEVIRME: kural KATALOGDA (featureCatalog.toggleFeature) — burada
  // degil. Panelde dursaydi test edilemezdi ve testin kopyaladigi kural ile
  // panelin uyguladigi kural sessizce ayrisirdi.
  const toggle = (f) => setDraft(d => toggleFeature(d, f.key));

  const doSave = async () => {
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    setSaving(true);

    // IZ ONCE YAZILIR (proje kurali, Ilke 3): degisiklik izsiz kalmasin.
    // Iz yazilip guncelleme patlarsa "denenmis ama uygulanmamis" gorunur;
    // tersi — izsiz uygulanmis degisiklik — kabul edilemez.
    const base = { actor_id: myProfile?.id ?? null, customer_id: customer.id, reason: reason.trim() };
    const rows = changed.map(k => ({
      ...base, type: 'config_change', field: k,
      old_value: isEnabled(saved, k), new_value: isEnabled(draft, k),
    }));
    if (limitChanged) rows.push({
      ...base, type: 'limit_change', field: 'max_users',
      old_value: customer.max_users ?? null, new_value: Number(maxUsers || 0),
    });
    if (esasDegisti) rows.push({
      ...base, type: 'config_change', field: 'ftl_hesap_esasi', old_value: esasKayitli, new_value: esas,
    });
    for (const d of degisenDegerler) rows.push({
      ...base, type: 'config_change', field: d.column,
      old_value: sayiOku(degerKayitli[d.column]), new_value: sayiOku(deger[d.column]),
    });

    const { error: logErr } = await supabase.from('superadmin_log').insert(rows);
    if (logErr) { setSaving(false); toast(`Audit write failed, nothing applied: ${logErr.message}`, 'error'); return; }

    const patch = { features: draft };
    if (limitChanged) patch.max_users = Number(maxUsers || 0);
    if (esasDegisti) patch.ftl_hesap_esasi = esas;
    for (const d of degisenDegerler) patch[d.column] = sayiOku(deger[d.column]);
    const { data, error } = await supabase.from('customers').update(patch).eq('id', customer.id).select().single();
    setSaving(false);
    if (error) { toast(error.message, 'error'); return; }

    setSaved(data.features || {});
    setEsasKayitli(data.ftl_hesap_esasi ?? null); setEsas(data.ftl_hesap_esasi ?? null);
    setDegerKayitli(ilkDegerler(data)); setDeger(ilkDegerler(data));
    setConfirming(false); setReason('');
    toast(`${customer.company_name} configuration saved.`, 'success');
    onSaved && onSaved(data);
  };

  const KIND = { module:'MODULE', cell:'CELL', button:'BUTTON' };

  // FTL HESAP ESASI (31 Eki 2026): FTL modülü satırının altında, yalnız bu şirket için. Modül KAPALIYKEN seçim görünmez,
  // saklanır — modül açılınca yine geçerli (onaylı örnek, 3. görünüm).
  const FtlEsasSecimi = ({ modulAcik }) => (
    !modulAcik ? (esas != null && (
      <div data-testid="ftl-esas-sakli" style={{ padding:'7px 12px 9px 34px', fontSize:10, color:C.t3 }}>
        FTL CALCULATION BASIS — kept ({ftlEsasEtiketi(esas)}), applies again when the module is turned on.
      </div>
    )) : (
      <div data-testid="ftl-esas-secimi" style={{ padding:'4px 12px 10px 34px' }}>
        <div style={{ fontSize:10, fontWeight:700, letterSpacing:1, color:C.t2, margin:'4px 0 6px' }}>
          FTL CALCULATION BASIS <span style={{ fontWeight:400, color:C.t3 }}>· this company only</span>
        </div>
        {FTL_ESAS_SECENEKLERI.map(o => {
          const secili = esas === o.deger;
          return (
            <div key={o.etiket} onClick={() => setEsas(o.deger)} data-testid={`ftl-esas-${o.deger ?? 'tur'}`}
                 role="radio" aria-checked={secili}
                 style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'7px 10px', marginBottom:4, cursor:'pointer',
                          borderRadius:6, border:`1px solid ${secili ? C.accent : C.border}`,
                          background: secili ? C.bg3 : 'transparent' }}>
              <span style={{ width:12, height:12, marginTop:2, borderRadius:'50%', flexShrink:0,
                             border:`2px solid ${secili ? C.accent : C.t3}`, background: secili ? C.accent : 'transparent' }} />
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:12, color:C.t1, fontWeight: secili ? 700 : 400 }}>
                  {o.etiket}
                  {esasDegisti && secili && <span style={{ marginLeft:8, fontSize:9, fontWeight:700, color:'var(--amber)' }}>CHANGED</span>}
                  {esasDegisti && esasKayitli === o.deger && <span style={{ marginLeft:8, fontSize:9, color:C.t3 }}>(was)</span>}
                </div>
                <div style={{ fontSize:10, color:C.t3, marginTop:2, lineHeight:1.35 }}>{o.aciklama}</div>
              </div>
            </div>
          );
        })}
      </div>
    )
  );

  const Section = ({ title, section }) => (
    <div style={{ marginBottom:22 }}>
      <div style={{ ...S.label, marginBottom:8 }}>{title}</div>
      {catalogTree(section).map(group => (
        <div key={group.module} style={{ border:`1px solid ${C.border}`, borderRadius:8, marginBottom:10, overflow:'hidden' }}>
          <div style={{ background:C.bg3, padding:'7px 12px', fontSize:11, fontWeight:700, color:C.t2 }}>{group.module}</div>
          {group.degerler.map(d => {
            const degisti = degisenDegerler.includes(d);
            const hatali  = hataliDegerler.includes(d);
            return (
              <div key={d.column} style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 12px', borderTop:`1px solid ${C.border}` }}>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:12, color:C.t1 }}>
                    {d.label}
                    {degisti && <span style={{ marginLeft:8, fontSize:9, fontWeight:700, color:'var(--amber)' }}>CHANGED</span>}
                  </div>
                  <div style={{ fontSize:10, color:C.t3, marginTop:2 }}>{d.column} · VALUE · this company only</div>
                  <div style={{ fontSize:10, color:C.t3, marginTop:2, lineHeight:1.35 }}>{d.aciklama}</div>
                  {hatali && (
                    <div data-testid={`deger-hata-${d.column}`} style={{ fontSize:10, color:'var(--red)', marginTop:3 }}>
                      NUMBER ONLY (e.g. 0.795)
                    </div>
                  )}
                </div>
                <input style={{ ...S.input, width:90, textAlign:'right', borderColor: hatali ? 'var(--red)' : undefined }}
                       type="number" step="0.001" data-testid={`deger-${d.column}`} value={deger[d.column]}
                       onChange={e => { const v = e.target.value; setDeger(x => ({ ...x, [d.column]: v })); }} />
              </div>
            );
          })}
          {group.items.map(f => {
            const on = isEnabled(draft, f.key);
            const moved = isEnabled(saved, f.key) !== on;
            const ebeveyn = f.dependsOn ? entryOf(f.dependsOn) : null;
            const kilitli = !!(f.dependsOn && !isEnabled(draft, f.dependsOn));
            return (
              <React.Fragment key={f.key}>
              <div style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 12px', borderTop:`1px solid ${C.border}` }}>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:12, color:C.t1 }}>
                    {f.label}
                    {moved && <span style={{ marginLeft:8, fontSize:9, fontWeight:700, color:'var(--amber)' }}>CHANGED</span>}
                  </div>
                  <div style={{ fontSize:10, color:C.t3, marginTop:2 }}>{f.key} · {KIND[f.kind]}</div>
                  {ebeveyn && (
                    <div data-testid={`bagimlilik-${f.key}`}
                         style={{ fontSize:10, color:'var(--amber)', marginTop:3, lineHeight:1.35 }}>
                      {kilitli
                        ? `"${ebeveyn.label}" KAPALI — bu anahtar da kapali ve acilamaz.`
                        : `"${ebeveyn.label}" kapatilirsa bu anahtar da KAPANIR; o tekrar acildiginda kendiliginden geri gelmez.`}
                    </div>
                  )}
                </div>
                <div onClick={() => toggle(f)}
                     data-testid={`anahtar-${f.key}`}
                     style={{ cursor: kilitli ? 'not-allowed' : 'pointer', opacity: kilitli ? 0.45 : 1, fontSize:10, fontWeight:700, padding:'4px 10px', borderRadius:4, minWidth:44, textAlign:'center', background: on ? 'rgba(45,158,95,0.15)' : 'rgba(224,32,32,0.15)', color: on ? 'var(--green)' : 'var(--red)' }}>
                  {on ? 'ON' : 'OFF'}
                </div>
              </div>
              {f.key === FTL_ESAS_ANAHTARI && <FtlEsasSecimi modulAcik={on} />}
              </React.Fragment>
            );
          })}
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ flex:1, overflowY:'auto', padding:'16px 20px' }}>
      {/* Bilesen olarak (<Section/>) DEGIL, fonksiyon olarak cagrilir: Section her cizimde yeniden tanimlanir, bilesen
          olsaydi alt agaci her tusta yeniden kurulur ve DEFAULT DENSITY hucresi odagi kaybederdi (3 Kas 2026). */}
      {Section({ title: 'UI — IPAD', section: 'ui' })}
      {Section({ title: 'WEB ADMIN', section: 'admin' })}

      <div style={{ marginBottom:22 }}>
        <div style={{ ...S.label, marginBottom:8 }}>LIMITS</div>
        <div style={{ border:`1px solid ${C.border}`, borderRadius:8, padding:'10px 12px', display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:12, color:C.t1, flex:1 }}>MAX USERS</span>
          <input style={{ ...S.input, width:90 }} type="number" value={maxUsers} onChange={e => setMaxUsers(e.target.value)} />
        </div>
      </div>

      {dirty && (
        <div style={{ position:'sticky', bottom:0, background:C.bg2, borderTop:`1px solid ${C.border}`, padding:'12px 0', display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:11, color:C.t2 }}>
            {[changed.length > 0 && `${changed.length} module change${changed.length === 1 ? '' : 's'}`,
              limitChanged && 'limit', esasDegisti && 'FTL calculation basis',
              ...degisenDegerler.map(d => d.label.toLowerCase())].filter(Boolean).join(' + ')}
          </span>
          {hataliDegerler.length > 0 && (
            <span data-testid="deger-kayit-kilidi" style={{ fontSize:11, color:'var(--red)' }}>
              {hataliDegerler.map(d => d.label).join(', ')}: NUMBER ONLY
            </span>
          )}
          <div style={{ flex:1 }} />
          <button style={S.btnSecondary} onClick={() => { setDraft(saved); setMaxUsers(String(customer.max_users ?? '')); setEsas(esasKayitli); setDeger(degerKayitli); }}>DISCARD</button>
          <button style={S.btnPrimary} onClick={() => setConfirming(true)} disabled={hataliDegerler.length > 0}>SAVE</button>
        </div>
      )}

      {confirming && (
        <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 }}>
          <div style={{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:12, width:560, maxHeight:vh(82), display:'flex', flexDirection:'column', overflow:'hidden' }}>
            <div style={{ background:C.bg3, padding:'10px 16px', borderBottom:`1px solid ${C.border}`, fontSize:12, fontWeight:700, color:C.accent,
                          display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
              <span>CONFIRM — {customer.company_name}</span>
              <KapatX onClose={() => setConfirming(false)} disabled={saving} />
            </div>
            <div style={{ padding:16, overflowY:'auto' }}>
              {closingKeys.length > 0 && (
                <>
                  <div style={{ ...S.label, marginBottom:6 }}>TURNING OFF — ALSO AFFECTED</div>
                  {affectsOf(closingKeys).map(a => (
                    <div key={a.key} style={{ border:`1px solid ${C.border}`, borderRadius:6, padding:'8px 10px', marginBottom:8 }}>
                      <div style={{ fontSize:12, color:'var(--red)', fontWeight:700 }}>{a.module} · {a.label}</div>
                      <ul style={{ margin:'6px 0 0 16px', padding:0 }}>
                        {a.affects.map((x, i) => <li key={i} style={{ fontSize:11, color:C.t2, marginBottom:2 }}>{x}</li>)}
                      </ul>
                      {a.note && <div style={{ fontSize:10, color:C.t3, marginTop:5 }}>{a.note}</div>}
                    </div>
                  ))}
                </>
              )}
              {openingKeys.length > 0 && (
                <>
                  <div style={{ ...S.label, marginBottom:6 }}>TURNING ON</div>
                  {affectsOf(openingKeys).map(a => (
                    <div key={a.key} style={{ fontSize:12, color:'var(--green)', marginBottom:4 }}>{a.module} · {a.label}</div>
                  ))}
                  <div style={{ fontSize:10, color:C.t3, marginBottom:10 }}>
                    Applies forward only — past flights are not regenerated.
                  </div>
                </>
              )}
              {esasDegisti && (
                <div data-testid="ftl-esas-onay" style={{ marginBottom:12 }}>
                  <div style={{ ...S.label, marginBottom:6 }}>FTL CALCULATION BASIS</div>
                  <div style={{ fontSize:12, color:C.t1, fontWeight:700, marginBottom:6 }}>
                    {ftlEsasEtiketi(esasKayitli)} → {ftlEsasEtiketi(esas)}
                  </div>
                  <ul style={{ margin:'0 0 0 16px', padding:0 }}>
                    <li style={{ fontSize:11, color:C.t2, marginBottom:2 }}>Only {customer.company_name} — the shared FTL rule set is not changed.</li>
                    <li style={{ fontSize:11, color:C.t2, marginBottom:2 }}>Duties assigned from now on (ASSIGN, flights archived from the iPad) are computed with the new basis.</li>
                    <li style={{ fontSize:11, color:'var(--amber)', marginBottom:2 }}>Existing duties keep the basis they were assigned with. To recalculate them, run ops/ftl_hesap_esasi_tazele.sql (iOS repo) in the SQL Editor after saving — the whole chain is recalculated and each change appears in FTL EDIT REPORT as SYSTEM RECALC.</li>
                  </ul>
                </div>
              )}
              {degisenDegerler.map(d => (
                <div key={d.column} data-testid={`deger-onay-${d.column}`} style={{ marginBottom:12 }}>
                  <div style={{ ...S.label, marginBottom:6 }}>{d.module} · {d.label}</div>
                  <div style={{ fontSize:12, color:C.t1, fontWeight:700, marginBottom:6 }}>
                    {sayiOku(degerKayitli[d.column]) ?? '—'} → {sayiOku(deger[d.column])}
                  </div>
                  <ul style={{ margin:'0 0 0 16px', padding:0 }}>
                    <li style={{ fontSize:11, color:C.t2, marginBottom:2 }}>Only {customer.company_name}.</li>
                    <li style={{ fontSize:11, color:C.t2, marginBottom:2 }}>{d.aciklama}</li>
                    <li style={{ fontSize:11, color:C.t2, marginBottom:2 }}>Densities already entered and archived flights are not changed.</li>
                  </ul>
                </div>
              ))}
              {limitChanged && (
                <div style={{ fontSize:12, color:C.t2, marginBottom:10 }}>
                  MAX USERS: {customer.max_users ?? '—'} → {Number(maxUsers || 0)}
                </div>
              )}
              <div style={S.formGroup}>
                <label style={S.formLabel}>REASON * (goes to the audit trail)</label>
                <HarfliGiris as="textarea" {...zAlan({ ...S.input, minHeight:64, resize:'vertical' }, true, gerekceTamam(reason))} data-testid="yapilandirma-gerekce" value={reason} onChange={v => setReason(v.toLocaleUpperCase('tr'))} placeholder="e.g. OM 8.3.2 — runway condition is recorded in the FMS" />
                <GerekceIpucu metin={reason} testid="yapilandirma-gerekce-ipucu" />
              </div>
            </div>
            <div style={{ padding:'12px 16px', borderTop:`1px solid ${C.border}`, display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button style={S.btnSecondary} onClick={() => setConfirming(false)}>CANCEL</button>
              <button style={S.btnPrimary} onClick={doSave} disabled={saving || !gerekceTamam(reason)}>{saving ? 'SAVING...' : 'APPLY'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function SuperAdminPanel({ onBack, onCikis }) {
  const [ready, setReady] = useState(false);
  const [dashCompany, setDashCompany] = useState(null);
  const [selected, setSelected] = useState(null);
  // Secili sirketin hangi bolumu acik: ayarlar mi, izleme mi.
  const [section, setSection] = useState('settings');
  // ŞİRKET SEÇİLMEDEN görünen üst seviye görünüm. Sürüm kaydı bir MÜŞTERİNİN
  // değil UYGULAMANIN verisi — o yüzden şirket ağacının altında değil, yanında.
  const [ustGorunum, setUstGorunum] = useState('companies');
  const [reloadKey, setReloadKey] = useState(0);
  const [email, setEmail] = useState('');
  const [myProfile, setMyProfile] = useState(null);
  const [profilHatasi, setProfilHatasi] = useState(null);   // okunamadı ≠ yok (21 Eki 2026)
  const [profilDeneme, setProfilDeneme] = useState(0);
  const [toast, setToast] = useState({ msg:'', type:'success' });
  const showToast = useCallback((msg, type='success') => {
    setToast({ msg, type });
    // 🔴 3 saniyelik otomatik kapatma KALDIRILDI (6 Eyl 2026): HATAYI da
    //    kapatiyordu. Kapanma karari artik `Bildirim`de — basari kisa,
    //    HATA kapatilana kadar durur (Serkan: "hemen kaybolmasin").
  }, []);

  useEffect(() => {
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { onBack(); return; }
      // 21 Eki 2026 (W4b): okunamayan profil "süper admin değil" SAYILMAZ — eskiden şirketsiz admin paneline
      // düşürüyordu. Okuma düşerse ProfilHatasi (RETRY / LOGOUT); süper admin olmadığı OKUNURSA eskisi gibi geri.
      const r = await profilOku(session.user.id);
      if (r.hata) { setProfilHatasi(r.hata); setReady(true); return; }
      setProfilHatasi(null);
      if (!r.profil?.is_super_admin) { onBack(); return; }
      setEmail(session.user.email || '');
      setMyProfile(r.profil);
      setReady(true);
    })();
  }, [onBack, profilDeneme]);

  if (!ready) return (
    <div style={{ display:'flex', width:TAM_GENISLIK, minHeight:TAM_YUKSEKLIK, background:C.bg, alignItems:'center', justifyContent:'center' }}>
      <div style={{ color:C.accent, letterSpacing:3, fontSize:11, fontFamily:'var(--mono)' }}>CHECKING AUTHORIZATION...</div>
    </div>
  );
  if (profilHatasi) return <ProfilHatasi hata={profilHatasi} onRetry={() => { setReady(false); setProfilDeneme(n => n + 1); }} sonra={onCikis} />;

  // Musterinin admin paneli: TAM EKRAN, kendi menusuyle — super admin orada
  // sirketin admini gibi gezer. Salt okunurdur (RLS dayatir), ust barda kirmizi
  // "VIEWING <sirket> — READ ONLY" bandi durur.
  if (dashCompany) return (
    <AdminPanel
      onBack={() => setDashCompany(null)}
      customerId={dashCompany.id}
      companyName={dashCompany.company_name}
    />
  );

  return (
    <div style={{ display:'flex', flexDirection:'column', minHeight:TAM_YUKSEKLIK, background:C.bg, fontFamily:'var(--mono)' }}>
      <Bildirim msg={toast.msg} type={toast.type} onClose={() => setToast({ msg:'', type:'success' })} />
      {/* UST BAR — admin panelin birebir dili (GO2 | baslik | rozet ... sag: eposta, tema, punto, cikis) */}
      <div style={{ background:C.bg2, borderBottom:`1px solid ${C.border}`, padding:'0 16px', height:50, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0, zIndex:100 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:12, color:C.accent, fontWeight:700, letterSpacing:3 }}>GO2</span>
          <span style={{ width:1, height:18, background:C.border }} />
          <span style={{ fontSize:10, color:C.t3, letterSpacing:2 }}>SUPER ADMIN</span>
          <span style={{ display:'inline-block', padding:'3px 9px', fontSize:9, letterSpacing:1, fontWeight:700, fontFamily:'var(--mono)', borderRadius:5, background:'var(--amber-soft)', color:'var(--amber)', border:'1px solid var(--line-soft)' }}>OWNER MODE</span>
          {selected && (
            <>
              <span style={{ width:1, height:18, background:C.border }} />
              <span style={{ fontSize:11, color:C.accent, fontWeight:700, letterSpacing:1 }}>{selected.company_name}</span>
              <span style={{ fontSize:10, color:C.t3 }}>{selected.home_base_icao}</span>
            </>
          )}
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:10, color:C.t3 }}>{email}</span>
          <ThemeToggle />
          <FontControls />
          {/* ← DASHBOARD KALKTI (1 Eki 2026, Serkan: "artık dashboard olmayacak"). */}
        </div>
      </div>

      <div style={{ flex:1, display:'flex', overflow:'hidden' }}>
        {/* SOL MENU */}
        <div style={{ width:250, borderRight:`1px solid ${C.border}`, background:C.bg2, display:'flex', flexDirection:'column', flexShrink:0 }}>
          <div style={{ flex:1, overflowY:'auto', padding:'10px 8px' }}>
            <div onClick={() => { setSelected(null); setUstGorunum('companies'); }}
                 style={navRow(!selected && ustGorunum === 'companies')}>
              <span style={navIcon(!selected && ustGorunum === 'companies')}>⌂</span>
              <span style={navText(!selected && ustGorunum === 'companies')}>Companies</span>
            </div>
            {/* 🔑 Serkan (21 Eyl 2026): *"Super adminde iOS revision and highlight
                sekmesi olcak."*  Surum kaydi + degisiklik ozeti; pilot uyarisi ve
                EASA konfigurasyon kontrolu (GM1(b)(3)) buradan beslenir. */}
            <div onClick={() => { setSelected(null); setUstGorunum('releases'); }}
                 data-testid="nav-ios-releases"
                 style={navRow(!selected && ustGorunum === 'releases')}>
              <span style={navIcon(!selected && ustGorunum === 'releases')}>⌥</span>
              <span style={navText(!selected && ustGorunum === 'releases')}>iOS Revisions</span>
            </div>
            {/* 🔑 Serkan (30 Eyl 2026): *"Süper adminde tip list … öyle bir modül olsun."*
                Ortak uçak tipi listesi bir MÜŞTERİNİN değil herkesin — şirket ağacının yanında. */}
            <div onClick={() => { setSelected(null); setUstGorunum('types'); }}
                 data-testid="nav-aircraft-types"
                 style={navRow(!selected && ustGorunum === 'types')}>
              <span style={navIcon(!selected && ustGorunum === 'types')}>✈</span>
              <span style={navText(!selected && ustGorunum === 'types')}>Aircraft Types</span>
            </div>
            {/* 🔑 Serkan (30 Eyl 2026): *"Bir de tescil arama modülü yapalım"* · *"bizimle çalışmış
                çalışan bütün tesciller (farklı şirketlerde olsa) görünür."* */}
            <div onClick={() => { setSelected(null); setUstGorunum('registrations'); }}
                 data-testid="nav-registrations"
                 style={navRow(!selected && ustGorunum === 'registrations')}>
              <span style={navIcon(!selected && ustGorunum === 'registrations')}>⌕</span>
              <span style={navText(!selected && ustGorunum === 'registrations')}>Registrations</span>
            </div>
            {/* 🔑 Serkan (30 Eyl 2026): *"Airport database işini süper admine taşıyalım, aynı aircraft
                gibi … bütün kullanıcılar görsün."* Ortak meydan listesi — şirket ağacının yanında. */}
            <div onClick={() => { setSelected(null); setUstGorunum('airports'); }}
                 data-testid="nav-airports"
                 style={navRow(!selected && ustGorunum === 'airports')}>
              <span style={navIcon(!selected && ustGorunum === 'airports')}>◎</span>
              <span style={navText(!selected && ustGorunum === 'airports')}>Airports</span>
            </div>

            {selected && (
              <>
                <div style={{ ...S.label, margin:'20px 10px 6px' }}>{selected.company_name}</div>
                {/* KUNYE EN USTTE: sirket NE ise once o. Ayarlar ve izleme
                    kunyenin uzerine oturur. */}
                <div onClick={() => setSection('profile')} style={navRow(section === 'profile')}
                     data-testid="nav-company-profile">
                  <span style={navIcon(section === 'profile')}>☰</span>
                  <span style={navText(section === 'profile')}>Company Profile</span>
                </div>
                <div onClick={() => setSection('settings')} style={navRow(section === 'settings')}>
                  <span style={navIcon(section === 'settings')}>⚙</span>
                  <span style={navText(section === 'settings')}>Settings</span>
                </div>
                {/* Sirketin ADMIN PANELI ic ice degil TAM EKRAN acilir — musterinin admini gibi gezilsin (salt okunur).
                    1 Eki 2026: eski adi Dashboard idi — web'deki Dashboard kalkinca yaniltici oldu (Serkan: "eski tanimlar ve
                    isimler kalmasin"). */}
                <div onClick={() => setDashCompany(selected)} style={navRow(false)} data-testid="nav-company-admin-panel">
                  <span style={navIcon(false)}>▤</span>
                  <span style={navText(false)}>Admin Panel</span>
                </div>
                {/* 15 Agu 2026, Serkan: pilotun rapor ettigi an + o ucusun tum
                    olay cizelgesi + taramadan cikan bulgular. */}
                <div onClick={() => setSection('monitoring')} style={navRow(section === 'monitoring')}>
                  <span style={navIcon(section === 'monitoring')}>◉</span>
                  <span style={navText(section === 'monitoring')}>Monitoring & Event Log</span>
                </div>
              </>
            )}
          </div>
          <div style={{ padding:'14px 16px', borderTop:`1px solid ${C.border}` }}>
            <div style={{ fontSize:10, color:C.t2, fontWeight:700, letterSpacing:1 }}>{email.split('@')[0].toUpperCase()}</div>
            <div style={{ fontSize:9, color:C.t3, letterSpacing:1, marginTop:3, marginBottom:10 }}>APP OWNER</div>
            {/* LOGOUT (3 Eki 2026, Serkan A) — admin paneldekinin aynısı, tek kaynak `CikisDugmesi`. */}
            <CikisDugmesi sonra={onCikis} />
          </div>
        </div>

        {/* ICERIK */}
        <div style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden', minWidth:0 }}>
          <div style={{ padding:'10px 16px', borderBottom:`1px solid ${C.border}`, background:C.bg3, flexShrink:0 }}>
            <span style={{ fontSize:10, color:C.accent, fontWeight:700, letterSpacing:3 }}>
              {selected
                ? `${selected.company_name.toUpperCase()} — ${
                    section === 'monitoring' ? 'SYSTEM MONITORING & EVENT LOG'
                  : section === 'profile'    ? 'COMPANY PROFILE'
                  : 'SETTINGS'}`
                : ustGorunum === 'releases' ? 'iOS REVISION AND HIGHLIGHT'
                : ustGorunum === 'types' ? 'AIRCRAFT TYPES'
                : ustGorunum === 'registrations' ? 'REGISTRATIONS'
                : ustGorunum === 'airports' ? 'AIRPORTS'
                : 'COMPANIES'}
            </span>
          </div>
          <div style={{ flex:1, display:'flex', overflow:'hidden' }}>
            {selected
              ? (section === 'monitoring'
                  ? <SystemMonitoring customer={selected} />
                  : section === 'profile'
                  ? <CompanyProfile customer={selected} toast={showToast} myProfile={myProfile}
                                    onSaved={(row) => { setSelected(row); setReloadKey(k => k + 1); }} />
                  : <Settings customer={selected} toast={showToast} myProfile={myProfile}
                              onSaved={(row) => { setSelected(row); setReloadKey(k => k + 1); }} />)
              : ustGorunum === 'releases'
              ? <AppReleases toast={showToast} myProfile={myProfile} />
              : ustGorunum === 'types'
              ? <AircraftTypes toast={showToast} myProfile={myProfile} />
              : ustGorunum === 'registrations'
              ? <Registrations />
              : ustGorunum === 'airports'
              ? <Airports toast={showToast} />
              : (
                  // APP OWNER ANA EKRANI: sirket listesinin ustunde testlerin
                  // durumu. Serkan burayi zaten aciyor; guvence gorunur yerde
                  // durmazsa kimse bakmaz.
                  <div style={{ flex:1, overflowY:'auto', padding:16 }}>
                    <SystemChecks />
                    {/* FTL gece taraması (3 Eki 2026, adım 6b — Serkan "A") — SYSTEM CHECKS'in tasarımıyla, hemen altında. */}
                    <FtlGeceDurumu />
                    <CompaniesList toast={showToast} myProfile={myProfile}
                               onSelect={(c) => { setSelected(c); setSection('profile'); }} reloadKey={reloadKey} />
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
}
